import { HelpersService } from './../../../services/helpers.service';
import { PaymentService } from './../../../services/payment.service';
import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem, ConfirmationService, MessageService } from 'primeng/api';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
} from '@angular/forms';
import { PartnerService } from 'src/app/services/partner.service';
import { CyclistService } from '../../../services/cyclist.service';
import moment from 'moment';

@Component({
  selector: 'app-user-edit',
  templateUrl: './user-edit.component.html',
  styleUrls: ['./user-edit.component.scss'],
  providers: [MessageService],
})
export class UserEditComponent implements OnInit {
  @Input() user;
  @Input() allocatedTechnicians;
  @Input() techniciansAllowed;
  @Input() defaultTab = 'DEFAULT';
  @Input() isWorkshop = true;
  @Input() isRentals = false;

  public partnerID: number = 0;
  public userTabItems: any;
  public selectedTab = 0;
  public activeItem: MenuItem;
  public UserForm: FormGroup;
  //public UserRoles = [];
  public isTechnicianOtherStore: boolean = false;
  public isFitterOtherStore: boolean = false;
  public technicianID: number = 0;
  public busy = false;
  error: boolean;
  errorMessage: string;
  public isCurrentUserAdmin = false;
  public isCurrentUserWorkshopManager = false;

  public isSuperUser = false;
  public isTechnician = false;
  public isFitter = false;
  public isAdmin = false;
  public isWorkshopManager = false;
  public isServiceLead = false;
  public isShopRideAdmin = false;
  public partner: any;

  constructor(
    public cyclistService: CyclistService,
    private partnerService: PartnerService,
    private helpersService: HelpersService,
    private translate: TranslateService,
    public modal: NgbActiveModal,
    private fb: FormBuilder,
    private confirmationService: ConfirmationService,
    private paymentService: PaymentService,
    public messageService: MessageService,
  ) {
    this.userTabItems = [
      {
        label: this.translate.instant('bikeshop.users.details'),
        command: () => {
          this.selectedTab = 0;
        },
      },
    ];
  }

  ngOnInit() {
    this.partnerID = this.helpersService.getPartnerId();
    this.partner = this.helpersService.getPartnerData();

    this.isSuperUser = this.helpersService.getProfileData()?.IsSuperUser;

    this.setupValidation();
    //this.getRoles();
    this.isCurrentUserAdmin =
      this.helpersService
        .getProfileData()
        .UserRoles.filter((x) => {
          return x.PartnerID === this.partnerID;
        })
        .map((x) => {
          return x.RoleID;
        })
        .indexOf(2) > -1 ||      
      this.helpersService.getProfileData().IsSuperUser;

    this.isCurrentUserWorkshopManager = this.helpersService
        .getProfileData()
        .UserRoles.filter((x) => {
          return x.PartnerID === this.partnerID;
        })
        .map((x) => {
          return x.RoleID;
        })
        .indexOf(3) > -1;

    if (this.user && this.user.TechnicianID) {
      this.technicianID = this.user.TechnicianID;
    }

    this.isTechnician =
      this.user.UserRoles.filter((x) => {
        return x.RoleID === 1;
      }).length > 0;
    this.isFitter =
      this.user.UserRoles.filter((x) => {
        return x.RoleID === 4;
      }).length > 0;
    this.isAdmin =
      this.user.UserRoles.filter((x) => {
        return x.RoleID === 2;
      }).length > 0;
    this.isWorkshopManager =
      this.user.UserRoles.filter((x) => {
        return x.RoleID === 3;
      }).length > 0;
    this.isServiceLead =
      this.user.UserRoles.filter((x) => {
        return x.RoleID === 9;
      }).length > 0;
    this.isShopRideAdmin =
      this.user.UserRoles.filter((x) => {
        return x.RoleID === 10;
      }).length > 0;
    this.activeItem = this.userTabItems[0];
    this.cyclistService.getCyclistById(this.user.ID).subscribe((cyclist) => {
      this.isTechnicianOtherStore =
        cyclist.UserRoles.filter((x) => {
          return x.RoleID === 1 && x.PartnerID !== this.partnerID;
        }).length > 0;
      this.isFitterOtherStore =
        cyclist.UserRoles.filter((x) => {
          return x.RoleID === 4 && x.PartnerID !== this.partnerID;
        }).length > 0;
    });
    if (this.techniciansAllowed == null) {
      this.paymentService.getPaymentStatus(this.partnerID).subscribe((res) => {
        this.techniciansAllowed = res.techniciansAllowed;
      });
    }
    if (this.isWorkshop) {
      this.userTabItems.push({
        label: this.translate.instant('bikeshop.users.roles'),
        command: () => {
          this.selectedTab = 1;
        },
      });
      this.setupExtraTabs();
    }

    if (this.defaultTab === 'AVAILABILITY' && this.userTabItems.length > 2) {
      this.selectedTab = 2;
      this.activeItem = this.userTabItems[2];
    }
  }

  setupExtraTabs() {
    this.userTabItems.splice(2, 10);

    if (this.isFitter || this.isTechnician) {
      this.userTabItems.push({
        label: this.translate.instant('bikeshop.users.availability'),
        command: () => {
          this.selectedTab = 2;
        },
      });
    }
    if (this.isTechnician) {
      this.userTabItems.push({
        label: this.translate.instant('bikeshop.users.servicetypes'),
        command: () => {
          this.selectedTab = 3;
        },
      });
    }
    if (this.isFitter) {
      this.userTabItems.push({
        label: this.translate.instant('bikeshop.users.fittings'),
        command: () => {
          this.selectedTab = 4;
        },
      });
    }
  }

  modelChanged(e, type) {
    if (type === 'Admin') {this.isWorkshopManager = false; this.isServiceLead = false; this.isShopRideAdmin = false; }
    if (type === 'WorkshopManager') {this.isAdmin = false; this.isServiceLead = false; this.isShopRideAdmin = false; }
    if (type === 'ServiceLead') {this.isAdmin = false; this.isWorkshopManager = false; this.isShopRideAdmin = false; }
    if (type === 'Technician') {this.isShopRideAdmin = false; }
    if (type === 'Fitter') {this.isShopRideAdmin = false; }
    if (type === 'ShopRideAdmin') {this.isAdmin = false; this.isWorkshopManager = false; this.isServiceLead = false; this.isTechnician = false; this.isFitter = false; }
  }

  /*getRoles() {
        this.partnerService.getRoles().subscribe((res) => {
          //this.roles = res.filter(x=>{return [1,2,3,4].indexOf(x.id)>-1});
          this.UserRoles = Array(this.roles.length).fill(false);
          this.user.UserRoles.forEach((x) => {
            this.UserRoles[x.RoleID - 1] = true;
          });
        });
      }*/

  setupValidation() {
    this.UserForm = this.fb.group({
      Name: new FormControl(this.user.Name, Validators.required),
      Surname: new FormControl(this.user.Surname, Validators.required),
      Email: new FormControl(this.user.Email, [
        Validators.required,
        Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$'),
      ]),
      PhoneNumber: new FormControl(
        this.user.PhoneNumber,
        Validators.nullValidator,
      ),
      Password: new FormControl('', Validators.required),
      ConfirmPassword: new FormControl('', Validators.required),
    });
  }

  unlinkUser() {
    this.confirmationService.confirm({
      key: 'user_key',
      header: this.translate.instant('general.confirm'),
      acceptLabel: this.translate.instant('general.yes'),
      rejectLabel: this.translate.instant('general.no'),
      message: this.translate.instant('messages.unlink_user_confirmation'),
      accept: () => {
        this.cyclistService
          .getCyclistById(this.user.ID)
          .subscribe((cyclist) => {
            cyclist.PartnerID = this.partnerID;
            cyclist.Partner = null;
            cyclist.IsPartnerUser = false;
            cyclist.ShowCyclistSite = true;
            cyclist.IsImpersonating = false;
            cyclist.Salutation =
              cyclist.Name +
              ' ' +
              cyclist.Surname +
              ' (' +
              cyclist.UserName +
              ')';
            cyclist.IsStravaLinked_Description = cyclist.IsStravaLinked
              ? 'Linked'
              : 'Not Linked';
            cyclist.Messages = [];
            this.cyclistService.unlinkCyclist(cyclist).subscribe((result) => {
              this.modal.close();
            });
          });
      },
    });
  }

  updateUser(formData) {
    let cyclist = this.user;
    cyclist.UserName = formData.Email;
    cyclist.Email = formData.Email;
    cyclist.Name = formData.Name;
    cyclist.Surname = formData.Surname;
    cyclist.PhoneNumber = formData.PhoneNumber;
    cyclist.DateOfBirth = moment().endOf('day').toISOString();
    cyclist.GenderID = formData.GenderID;

    cyclist.IsPartnerUser = true;
    cyclist.ShowCyclistSite = true;
    cyclist.IsImpersonating = false;
    cyclist.Salutation =
      cyclist.Name + ' ' + cyclist.Surname + ' (' + cyclist.UserName + ')';
    cyclist.IsStravaLinked_Description = cyclist.IsStravaLinked
      ? 'Linked'
      : 'Not Linked';
    cyclist.Messages = [];
    cyclist.UserRoles = [];
    cyclist.PartnerID = this.partnerID;
    this.busy = true;
    this.cyclistService.saveCyclist(cyclist).subscribe(
      (user) => {
        this.modal.close();
        this.messageService.add({
          life: 5000,
          detail: this.translate.instant('messages.user_updated', {
            name: cyclist.Name,
          }),
        });
        this.busy = false;
      },
      (err) => {
        this.modal.close();
        this.messageService.add({ life: 5000, detail: err });
        this.busy = false;
      },
    );
  }

  UpdateRoles() {
    this.busy = true;
    let UserRoles = [];
    if (this.isAdmin) UserRoles.push(2);
    if (this.isWorkshopManager) UserRoles.push(3);
    if (this.isServiceLead) UserRoles.push(9);
    if (this.isShopRideAdmin) UserRoles.push(10);
    if (this.isTechnician) UserRoles.push(1);
    if (this.isFitter) UserRoles.push(4);

    if (UserRoles.length !== 0) {
      this.cyclistService
        .updateRoles(
          this.user.ID,
          UserRoles,
          this.helpersService.getPartnerId(),
        )
        .subscribe(
          (user) => {
            this.messageService.add({
              life: 5000,
              detail: this.translate.instant('messages.user_updated', {
                name: this.user.Name,
              }),
            });
            this.busy = false;
            this.modal.close();
          },
          (err) => {
            this.modal.close();
            this.messageService.add({ life: 5000, detail: err });
            this.busy = false;
          },
        );
    } else {
      this.busy = false;
      this.error = true;
      this.errorMessage = this.translate.instant('bikeshop.users.missing_role');
    }
  }
}
